export function isEqualCaseInsensitive(a: string, b: string) {
	return a.toLowerCase() === b.toLowerCase();
}
